import React from 'react';
import {Trans} from 'react-i18next';
import PageMeta from '../../components/PageMeta';
import { Container } from 'react-bootstrap';
import Header from '../../components/Header';
import Footer from "../../components/Footer";

const About = () => {
    return (
        <>
            <PageMeta page="about" path="/about"/>
            <Header/>
            <Container as="main" className="content-page">
                <h1><Trans>pages.about.0.title</Trans></h1>
                <p><Trans>pages.about.0.description</Trans></p>
                <h2><Trans>pages.about.1.title</Trans></h2>
                <p><Trans>pages.about.1.description</Trans></p>
                <h2><Trans>pages.about.2.title</Trans></h2>
                <p><Trans>pages.about.2.description</Trans></p>
            </Container>
            <Footer/>
        </>
    );
};

export default About;
